// Enum for different types of trips.
export const TripType = Object.freeze({
  ON_DEMAND: 'on_demand', // default
  INTERNAL_FIXED: 'fixed_internal',
  EXTERNAL_FIXED: 'fixed_external',
  ON_FOOT: 'on_foot' // technically not trip type but for when traveling between from origin to pickup, dropoff to pickup, and dropff to destination
});
